import { Button } from '../design-system/Button';
import { SkipBolt } from './SkipBolt';
import { BuybackRippleWaves } from './BuybackRippleWaves';

type Props = {
  label: string;
  onClick: () => void;
};

/** The demo result's main action: full-width, with the bolt and the ripple waves. */
export function DemoPrimaryAction({ label, onClick }: Props) {
  return (
    <div className="relative w-full">
      <BuybackRippleWaves />
      <Button
        variant="primary"
        size="xl"
        onClick={onClick}
        fullWidth
        // No gap of its own: the bolt's slot carries the gap and
        // animates it, so the label glides as the bolt folds
        className="relative z-10 h-16 gap-0"
        leftIcon={<SkipBolt />}
      >
        {label}
      </Button>
    </div>
  );
}

/** The demo result's other action: a quiet underlined link under the main one. */
export function DemoSecondaryAction({ label, onClick }: Props) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="mx-auto !h-auto !px-0 underline underline-offset-4 type-subhead font-normal"
    >
      {label}
    </Button>
  );
}
